// BlockingRulesSection.tsx
import React from "react";
import SectionCard from "./SectionCard";
import Toggle from "./Toggle";
import { BlockingRulesData } from "./types";

interface Props {
  data: BlockingRulesData;
  onChange: (data: BlockingRulesData) => void;
}

export default function BlockingRulesSection({ data, onChange }: Props) {
  const set = (key: keyof BlockingRulesData, value: boolean) =>
    onChange({ ...data, [key]: value });

  return (
    <SectionCard step={2} title="Order Blocking Rules">
      <div className="flex justify-between items-start border-b border-gray-100 pb-4">
        <div>
          <p className="text-sm font-medium">Block Orders When Credit Limit Exceeded</p>
          <p className="text-xs text-gray-400">Prevent order confirmation when outstanding exceeds credit limit</p>
        </div>
        <Toggle on={data.blockOnExceed} onToggle={(v) => set("blockOnExceed", v)} />
      </div>

      <div className="grid sm:grid-cols-2 gap-4 bg-gray-50 rounded-lg p-4">
        <div className="flex justify-between items-start">
          <div>
            <p className="text-sm font-medium">Allow Order Creation (Draft)</p>
            <p className="text-xs text-gray-400">Allow staff to create order as draft and send for approval</p>
          </div>
          <Toggle on={data.allowDraftOrders} onToggle={(v) => set("allowDraftOrders", v)} />
        </div>

        <div className="flex justify-between items-start">
          <div>
            <p className="text-sm font-medium">Require Admin Approval</p>
            <p className="text-xs text-gray-400">Admin approval is required for orders exceeding credit limit</p>
          </div>
          <Toggle on={data.requireApproval} onToggle={(v) => set("requireApproval", v)} />
        </div>
      </div>
    </SectionCard>
  );
}
